import { HTMLInputTypeAttribute } from "react";

interface Props {
  label?: string;
  value?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
}

export const Checkbox = ({
  label,
  value,
  onChange,
  type,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  disabled,
  ...rest
}: Props) => {
  const checkboxId = `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="flex items-center mb-4">
      <input
        id={checkboxId}
        type="checkbox"
        checked={value}
        onChange={onChange}
        disabled={disabled}
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        {...rest}
      />
      {label && (
        <label
          htmlFor={checkboxId}
          className={`ms-2 text-sm font-satoshi font-medium text-gray-900 dark:text-gray-300 cursor-pointer ${labelClassName || ""}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};
